// bark core
import { init as initCore, initChameleon } from "@bark/bark-core";

//router
import { routerUrl } from "./router";

// run
export async function main() {

    // core functions
    await initCore();

    //services
    initChameleon();

    // router functions
    routerUrl();
}

main().then(async () => {
    console.log("buyers app start..");
});
